import React, { useState, useEffect, useRef } from "react"
import fields from "models/arcLot"
import * as Yup from "yup"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import _ from "lodash"
import currentUser from "helpers/currentUser"
import fieldStatus from "helpers/fieldStatus"
import settings from "settings"
import { Formik, Field, Form, FieldArray } from "formik"
import { toast } from "react-toastify"
import superagent from "superagent"
import DateField from "components/DateField"
import submitData from "helpers/submitData"
import helpers from "helpers/helpers"

const ArcFinalSubmit = (props) => {
	const user = currentUser()
	const file = useRef(null)

	let rejReason
	if (props?.data?.arc_data?.fr_rejection_reason) {
		rejReason = (
			<p className="my-2 px-5 py-2 text-white bg-red-500 inline-block">
				Rejection Reason: {props.data.arc_data.fr_rejection_reason}
			</p>
		)
	}

	const validation = () => {
		return Yup.object().shape({
			fr_review_date: Yup.number().required("Required"),
		})
	}

	const handleSubmit = () => {
		if (!file.current) return
		let req = superagent.post(settings.ep + "/arcSubmitFinalReview")
		let f = file.current.files[0]
		if (f && f.size) {
			req.attach("plan_file", f)
		}
		req.field("data", JSON.stringify({ id: props.data.id, user: user.id }))
		req.set("Authorization", user)
		req.end((e, resp) => {
			if (e) {
				console.log(e)
				toast.error(`Error encountered when updating lot.`)
				return
			}
			props.notify({ status: 200, message: resp.body.message }, "finalModal")
		})
	}

	const FinalForm = () => {
		//if (user?.group !== 15) return ""
		let fields = {
			fr_review_date: "",
		}
		if (props?.data?.arc_data?.fr_review_date) fields.fr_review_date = props.data.arc_data.fr_review_date
		return (
			<Formik
				enableReinitialize
				initialValues={fields}
				validationSchema={validation}
				validateOnMount={true}
				onSubmit={(values) => {
					props.loadingStatus(true)
					values.id = props.data.id
					submitData("mainIngest", { ...values, action: "inputFinalReviewDate" })
						.then(async (data) => {
							toast.success(data.message)
							await props.getPayload()
							props.loadingStatus(false)
						})
						.catch((e) => {
							toast.error(`Could not submit final review date.`)
							props.loadingStatus(false)
							console.log(e)
						})
				}}>
				{(f) => (
					<Form>
						<ul className="form__list">
							<li className={fieldStatus("fr_review_date", f)}>
								<label htmlFor="fr_review_date">
									Final Review Date <sup>*</sup>
								</label>
								{f.errors.fr_review_date && f.touched.fr_review_date && (
									<div className="form__message">{f.errors.fr_review_date}</div>
								)}
								<DateField
									name="fr_review_date"
									className="form__input"
									placeholder="Tour Date"
									value={f.values.fr_review_date}
									onChange={f.setFieldValue}
									onBlur={f.setFieldTouched}
									touched={f.touched.fr_review_date}
									error={f.errors.fr_review_date}
									outXDays={7}
								/>
							</li>
						</ul>
						<input type="submit" value="Submit" className={helpers.submitClasses(f.isValid)} />
					</Form>
				)}
			</Formik>
		)
	}

	const FileView = () => {
		//? This is legacy, keeping in case we need to get files again for final reviews.
		return
		if (user.group === 15) return ""
		return (
			<>
				<h3 className="pt-5">Plan File</h3>
				<input type="file" ref={file} />
				<button className="px-4 py-2 text-white bg-green-700" onClick={handleSubmit}>
					Submit
				</button>
			</>
		)
	}

	return (
		<div className="modal">
			<h3>Submit Final Approval for {props?.data?.address}</h3>
			{rejReason}
			<FinalForm />
		</div>
	)
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return {
		getPayload: (...args) => dispatch(getPayload(...args)),
		loadingStatus: (...args) => dispatch(loadingStatus(...args)),
	}
}

export default connect(mapStateToProps, matchDispatchToProps)(ArcFinalSubmit)
